<template>
  <loading v-if="loading"/>
</template>

<script>
import VueCookies from 'vue-cookies'
import store from "@/state/store"

import getListLocation from "@/mixins/items/getListLocation";

import { AuthService } from "@/services/auth.service"
import { PackageService } from "@/services/nextshop/package.service";
import Loading from '../../components/Loading.vue';
import { LOGIN_LINK } from '../../utils/contants';
import { removeStorageItem } from '@/utils/auth'

export default {
  components: { Loading }, 
  name: 'token',

  mixins: [getListLocation],

  data() {
    return {
      loading: true,
      checkChangePlan: false
    }
  },

  async created() {
    this.loading = true
    await this.checkHasActivePlan()
    this.loading = false
  },
  methods: {
    async merchantPlanConfigs() {
      try {
        const response = await PackageService.merchantPlanConfigs()
        if (response.success) {
          if(response.data.plan == null || response.data.plan == ''){
            removeStorageItem('locationName')
						AuthService.packageBackHome()
          }else{
            this.checkChangePlan = response.data.planChanged
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async checkHasActivePlan(){
      const url_string = window.location.href
      const url = new URL(url_string)

      const token = url.searchParams.get("token")
      const userId = url.searchParams.get("userId")
      const merchantId = url.searchParams.get("merchantId")
    
      try {
        const response = await AuthService.loginNext360({
          merchantId: merchantId,
          token: token,
          userId: userId
        })
        
        if (response.success && store.getters["auth/loggedIn"]) {
          const response = await PackageService.checkMerchantHasPlan()
          const resLocation = await this.getListLocation()

          const listLocations = resLocation.map(e => {
            return {
              name: e.name,
              id: e.coLocationId
            }
          })

          store.commit("auth/SET_lIST_LOCATIONS", listLocations);
  
          VueCookies.set("ACTIVE",response.data.hasActivePlan)

          if (response.data.hasActivePlan) {
            await this.merchantPlanConfigs()
            await this.checkPlanRedirect()
          } else {
            this.$router.push('/package-select')
          }
        }
      } catch (error) {
        location.href = LOGIN_LINK
      }
    },
    async checkPlanRedirect(){
      const inforUsers = JSON.parse(localStorage.getItem("auth.currentUser"))
      await this.merchantPlanConfigs()
      if(this.checkChangePlan){
        if(inforUsers.role == 'employee'){
          this.$router.push('/forbidden')
        }else{
          this.$router.push('/package-select-v2')
        }
      }else{
        this.$router.push('/dashboard')
      }
    }
  }
}
</script>

<style>

</style>